import httpClient from "@/api/httpClient";
import { fetchCdnJson } from "@/api/fetchCdnJson";
import ConfigService from "@/services/ConfigService";
import { UserProgressInPromos, UserSpinData } from "../casino.types";

class casinoService {
  static getCasinoData = async (promoId: string) => {
    const response = await httpClient.get(`/casino/${promoId}`);

    return response.data;
  };

  static getPromoTerms = async (promoId: string, lang: string) => {
    try {
      return await fetchCdnJson(`${ConfigService.cdnBaseURL}/promo/${promoId}/${lang}.json`);
    } catch {
      if (lang === "en") return null;
      try {
        return await fetchCdnJson(`${ConfigService.cdnBaseURL}/promo/${promoId}/en.json`);
      } catch {
        return null;
      }
    }
  };

  static getBadgeLobby = async () => {
    const response = await httpClient.get(`/badge/lobby/organization`);

    return response.data;
  };

  static getOptInStatus = async (promoId: string) => {
    const response = await httpClient.get(`/opt-in/${promoId}`);

    return response.data;
  };

  static optIn = (promoId: string) => httpClient.post(`/opt-in/${promoId}`, {});

  static getUserProgress = async (promoId: string) => {
    const response = await httpClient.get(`/casino/${promoId}/user/progress`);

    return response.data;
  };

  static getUserProgressInPromos = async (promoRefs: string[]): Promise<UserProgressInPromos[]> => {
    const response = await httpClient.get(`/casino/user/progress`, {
      params: { promoRefs: promoRefs.join(",") },
    });

    return response.data;
  };

  static getStreakStatus = async (promoId: string) => {
    const response = await httpClient.get(`/casino/${promoId}/streak`);

    return response.data;
  };

  static claimStreakRewards = async (promoId: string, casinoRewardIds: number[]) => {
    const response = await httpClient.post(`/casino/${promoId}/streak/claim`, {
      casinoRewardIds,
    });

    if (!Array.isArray(response.data)) {
      throw new Error(response.data?.error?.message || "Streak claim failed");
    }

    return response;
  };

  static getUserSpins = async (promoId: string): Promise<UserSpinData> => {
    const response = await httpClient.get(`/casino/${promoId}/spin`);

    return response.data;
  };

  static spin = (promoId: string) => httpClient.post(`/casino/${promoId}/spin`);

  static getUserSymbols = async (promoRef: string) => {
    const response = await httpClient.get(`casino/${promoRef}/user/symbols`);

    return response.data ?? [];
  };
}

export default casinoService;
